export enum SwedenDriverWorkYearsPeriods {
  All = -2,
  None = -1,
  Below2 = 0,
  Above2 = 1,
  Above4 = 2,
  Above6 = 3,
}
